import { PARIS_LAT, PARIS_LNG } from '@/features/gmaps/constants';

export const getGoogleMapAddress = (
  googleMaps,
  address: string,
  selectedPlaces: Array<{ label: string; name?: string }> = [],
  types = ['geocode'],
) =>
  new Promise((resolve, reject) => {
    if (googleMaps) {
      const autoCompleteService = new googleMaps.places.AutocompleteService();

      if (autoCompleteService) {
        googleMaps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input: address,
          locationBias: new googleMaps.LatLng(PARIS_LAT, PARIS_LNG),
          includedPrimaryTypes: types,
        })
          .then(({ suggestions }) => {
            const formattedResults = suggestions.map(suggest => {
              return {
                label: suggest.placePrediction.text.toString(),
                name: suggest.placePrediction.text.toString(),
                value: suggest.placePrediction.placeId,
                placeId: suggest.placePrediction.placeId,
                suggest,
              };
            });

            resolve(
              selectedPlaces?.length > 0
                ? [...selectedPlaces, ...formattedResults]
                : formattedResults,
            );
          })
          .catch(reject);
      }
    }
  });
